/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React from "react";
import { shape, arrayOf, string, object, number } from "prop-types";
// eslint-disable-next-line import/no-cycle
import {
	SecondaryCard,
	SenaryCard,
	PrimaryCard,
	TertiaryCard,
	QuaternaryCard,
	CruiseCard,
	BrandCard,
	HeroCard,
	HotelCardTopResults,
	BlogCard,
	SingleCard,
	NoBorderCard,
	SquareCard,
} from "../../Card";
import {
	cloudinaryImageToSrcUrlAdapter,
	cloudinaryImageAdapter,
} from "../../../sharedComponents/CloudinaryImageAdapter";
// eslint-disable-next-line import/no-cycle
import { CardsContainerSlide } from "../../CardsContainer";
// import { ComponentWrapper } from "../../ComponentWrapper/ComponentWrapper";
import { Heading } from "../../Headings/Heading";

// TODO:: Task 99842: CardCollection, Tile Slider and Paginated collection Update

const TileSlider = ({ title, tiles, variant, id, slidesPerPage }) => {
	let Card = SecondaryCard;
	if (variant === "senary") {
		Card = SenaryCard;
	} else if (variant === "primary") {
		Card = PrimaryCard;
	} else if (variant === "tertiary") {
		Card = TertiaryCard;
	} else if (variant === "quaternary") {
		Card = QuaternaryCard;
	} else if (variant === "cruise") {
		Card = CruiseCard;
	} else if (variant === "brand") {
		Card = BrandCard;
	} else if (variant === "topHotel") {
		Card = HotelCardTopResults;
	} else if (variant === "hero") {
		Card = HeroCard;
	} else if (variant === "blog") {
		Card = BlogCard;
	} else if (variant === "single") {
		Card = SingleCard;
	} else if (variant === "noborder") {
		Card = NoBorderCard;
	} else if (variant === "square") {
		Card = SquareCard;
	}

	return (
		<>
			{title && (
				<Heading as="h2" size="h1" center className="margin-bottom-lg">
					{title}
				</Heading>
			)}
			{tiles && (
				<CardsContainerSlide id={id} slidesPerPage={slidesPerPage}>
					{tiles.map(tile => (
						<Card
							key={tile.id}
							id={tile.id}
							header={tile.displayTitle}
							variant={tile.variant}
							subheader={tile.subTitle}
							subheader2={tile.subTitle2}
							color={tile.color}
							content={tile?.content?.childMarkdownRemark?.html}
							stars={tile?.stars}
							minAge={tile?.minAge}
							icon={tile?.icon}
							button={tile?.button}
							link={
								tile.link && {
									to: tile.link.url,
									target: tile.link.target,
									text: tile.link.linkText || tile.link.displayTitle || tile.title,
								}
							}
							image={{
								...cloudinaryImageAdapter({
									cloudinaryImage:
										tile?.cloudinaryImage?.[0] || tile?.sourceSet?.[0]?.cloudinaryAsset?.[0],
									maxWidth: 400,
									title: tile.displayTitle,
									desc: tile.displayTitle,
								}),
							}}
							logo={{
								alt: tile.title,
								src: cloudinaryImageToSrcUrlAdapter(tile?.logo?.[0]),
							}}
							checklist={tile.checkListItems}
						/>
					))}
				</CardsContainerSlide>
			)}
		</>
	);
};
TileSlider.propTypes = {
	title: string,
	variant: string,
	id: string,
	slidesPerPage: number,
	tiles: arrayOf(
		shape({
			id: string,
			title: string,
			link: shape({
				url: string,
				target: string,
			}),
			image: shape({
				file: shape({
					url: string,
				}),
			}),
			sourceSet: arrayOf(object),
			cloudinaryImage: arrayOf(object),
			logo: arrayOf(object),
			checkListItems: arrayOf(object),
		})
	),
};

TileSlider.defaultProps = {
	title: null,
	variant: null,
	tiles: [],
	id: null,
	slidesPerPage: 3,
};

export default TileSlider;
export { TileSlider };
